import React from 'react'
import ChildDetails from './child-details'
import Evidence from './evidence'
import ProvidingBody from './providing-body'
import RiskReasons from './risk-reasons'
import ExtensionReasons from './extension-reasons'
import StateDetails from './state-details'

const ACCSForm = (props) => {
  const { readOnly, values, onChange, isDetermination } = props

  const generateHeader = () => {
    const pre = readOnly ? 'View' : 'New'
    const post = isDetermination ? 'Determination' : 'Certificate'
    return `${pre} ${post}`
  }

  return (
    <div>
      <h2>{generateHeader()}</h2>
      <hr />
      <ChildDetails
        readOnly={readOnly}
        values={values}
        onChange={onChange}
        isDetermination={isDetermination} 
      />
      <hr />
      <RiskReasons
        readOnly={readOnly}
        isDetermination={isDetermination}
        onChange={onChange}
        values={values}
      />
      <hr />
      {isDetermination && values.weeks_at_risk > 13 &&
        <ExtensionReasons 
          onChange={onChange}
          values={values}
        />
      }
      <hr />
      <Evidence
        readOnly={readOnly}
        isDetermination={isDetermination}
        onChange={onChange}
        values={values}
      />
      <hr />
      <ProvidingBody
        readOnly={readOnly}
        isDetermination={isDetermination}
        onChange={onChange}
        values={values}
      />
      <hr />
      <StateDetails
        readOnly={readOnly}
        isDetermination={isDetermination}
        onChange={onChange}
        values={values}
      />
      <hr />
    </div>
  )
}
export default ACCSForm



// WEBPACK FOOTER //
// ./src/care-enrolments/accs/form/index.js